import axios from '@/api/api-request'

const projectUrl = '/baseStandard'

// 企标管理-获取企标列表
export const entList = (data) => {
  return axios.request({
    url: projectUrl + '/entList.do',
    method: 'post',
    data: data
  })
}
// 企标管理-获取企标信息
export const getEnt = (params) => {
  return axios.request({
    url: projectUrl + '/getEnt.do',
    method: 'post',
    params: params
  })
}
